import { DEFAULT_QUERY_PARAMS, DEFAULT_QUERY_PARAMS_WITH_SORT, QueryParams } from '../models/query-params';
import { queryParamsStorageService } from './query-params-storage.service';

/**
 * Get default query param.
 * @returns {QueryParams}
 */
function getDefaultQueryParams() {
  const perPageFromStorage = queryParamsStorageService.getDefaultPerPage();
  if (perPageFromStorage == null) {
    return DEFAULT_QUERY_PARAMS;
  }
  return new QueryParams({ ...DEFAULT_QUERY_PARAMS, perPage: perPageFromStorage });
}

/**
 * Get default query param with sort.
 * @returns {QueryParams}
 */
function getDefaultQueryParamsWithSort() {
  const perPageFromStorage = queryParamsStorageService.getDefaultPerPage();
  if (perPageFromStorage == null) {
    return DEFAULT_QUERY_PARAMS_WITH_SORT;
  }
  return new QueryParams({ ...DEFAULT_QUERY_PARAMS_WITH_SORT, perPage: perPageFromStorage });
}

export const queryParamsService = {
  getDefaultQueryParams,
  getDefaultQueryParamsWithSort,
};
